export default "__VITE_ASSET__BMTyvY_E__"